'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.default = void 0;
var auth = _interopRequireWildcard(require('../auth/auth'));
function _interopRequireWildcard(e) {
    if (e && e.__esModule)
        return e;
    var r = {};
    if (null != e)
        for (var t in e)
            if (Object.prototype.hasOwnProperty.call(e, t)) {
                var o = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(e, t) : {};
                o.get || o.set ? Object.defineProperty(r, t, o) : r[t] = e[t];
            }
    return r.default = e, r;
}
var _default = auth;
exports.default = _default;